export const PENDING_STATUS = 'Pending';
export const CANCELED_STATUS = 'Canceled';
export const APPLIED_STATUS = 'Applied';
export const PROCESSING_STATUS = 'Processing';

export enum EMonthlyFeeStatus {
	PENDING = 'Pending',
	CANCELED = 'Canceled',
	APPLIED = 'Applied',
	PROCESSING = 'Processing',
}
